import { PERSONAS } from "src/data/personas";

export const selectPersonas = () => PERSONAS;



// WEBPACK FOOTER //
// ./src/scenes/personas/store/personas.selectors.js